import { callFunction } from './functionsClient';
import type { Transaction } from '../types';

export const walletApi = {
  getBalance: () => callFunction<{ balance: number }>('get-balance'),
  getTransactions: (before?: number, pageSize = 20) =>
    callFunction<{ items: Transaction[]; nextCursor: number | null }>(
      'get-transactions',
      { query: { before, pageSize } },
    ),
};
